module.exports = __webpack_public_path__ + "static/media/hourglass.2a4be042.svg";